module.exports = __webpack_public_path__ + "static/media/muuve-full.a0be9d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/muuve-full.png
// module id = 2207
// module chunks = 0